import React from 'react';
import './Appointments.scss';
import { ContentBlock } from 'components/ContentBlock/ContentBlock';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Appointment } from 'services/appointment/appointment.types';

export const Appointments: React.FunctionComponent<{
    isLoading: boolean;
    data: Appointment[];
}> = ({ isLoading, data }) => {
    const navigate = useNavigate();

    return (
        <ContentBlock isLoading={isLoading} title="Demandes de rendez-vous" className="appointments">
            {data.length > 0 ? (
                <div className="appointments-container">
                    {data.map((item) => (
                        <div
                            className="appointment-item"
                            key={'persons-appointments-' + item.id}
                            onClick={() => navigate(`/app/admin/persons/${item.person_id}/appointments`)}
                        >
                            <div className="appointment">
                                <div className="day">
                                    <span className="number">{moment(item.started_at).format('DD')}</span>
                                    <span className="month">{moment(item.started_at).format('MMM')}</span>
                                </div>
                                <div className="hours">
                                    <div className="start">{moment(item.started_at).format('HH:mm')}</div>
                                    <div className="end">{moment(item.ended_at).format('HH:mm')}</div>
                                </div>
                                <div className="separator"></div>
                                <div className="description">
                                    <span className="nature">{item.label}</span>
                                    <span className="person">Demandé par {item.person}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="no-appointment">Aucune demande de rendez-vous</div>
            )}
        </ContentBlock>
    );
};
